@if (options) {
  <div class="mat-dialog-custom confirmation-dialog" [id]="options.dialogId">
    @if (options.titleText) {
      <div class="title-container">
        <h1 class="title">{{ options.titleText }}</h1>
      </div>
    }
    @if (options.contentText) {
      <div class="body-container">
        <mat-form-field class="helper-full-width">
          <mat-label>{{ options.contentText }}</mat-label>
          <input name="inputId" tabindex="0" matInput required [id]="options.inputId" [formControl]="inputValue" />
          @if (inputValue.invalid && (inputValue.dirty || inputValue.touched)) {
            <mat-error>{{ options.contentText }} <ng-container i18n>is required.</ng-container></mat-error>
          }
        </mat-form-field>
        <div class="buttons-container">
          <button
            id="confirmDialogConfirmButton"
            class="button primary-button helper-full-width"
            type="submit"
            tabindex="0"
            [mat-dialog-close]="inputValue.value"
            [rdcAnalytics]="options.confirmAnalyticsTag"
          >
            {{ options.confirmText }}
          </button>
          @if (!options.hideCancelButton) {
            <button
              id="confirmDialogCancelButton"
              class="button secondary-button helper-full-width"
              type="button"
              mat-dialog-close="cancel"
              tabindex="0"
              [rdcAnalytics]="options.cancelAnalyticsTag"
            >
              {{ options.cancelText }}
            </button>
          }
        </div>
      </div>
    }
  </div>
}
